export default __webpack_public_path__ + "static/media/in_point_charge.bce93da0.svg";